import { useFormat } from '@ideavivat/vivat-2';
import usePurchaseRequest from '@/use/usePurchaseRequest';

const { typeTranslate, translate, classMap } = usePurchaseRequest();

export default {
  types: {
    _primaryControls: {
      name: 'เมนู',
      width: '3rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
      class: 'text-center',
    },
    status: {
      name: 'สถานะ',
      width: '6rem',
      class: {
        text: (val: string, row: { item: { [key: string]: any }; index: number }) => classMap(val, row.item.approved),
      },
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => translate(val, row.item.approved),
    },
    // itemsType: {
    //   name: 'ประเภท',
    //   width: '6rem',
    //   class: {
    //     text: (val: string, row: { item: { [key: string]: any }; index: number }) => classMap(val, true),
    //   },
    //   filter: (val: string, row: { item: { [key: string]: any }; index: number }) => typeTranslate(val),
    // },
    bomCode: {
      name: 'Bom',
      width: '8rem',
      // eslint-disable-next-line
      filter: (val: string, row: any) => row.item.bom?.code ? row.item.bom?.code : '-',
      class: {
        cell: 'text-center',
        text: 'text-center',
      },
    },
    code: {
      name: 'เลขที่รายการ',
      width: '1fr',
    },
    dueDate: {
      name: 'ต้องการภายใน',
      width: '12rem',
      class: 'text-right',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayFullThaiDate() : '',
    },
    updated_at: {
      name: 'วันทำรายการล่าสุด',
      width: '12rem',
      class: 'text-right',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDateTime() : '',
    },
    created_at: {
      name: 'วันที่สร้างรายการ',
      width: '12rem',
      class: 'text-right',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDateTime() : '',
    },
    creator: {
      name: 'ผู้ทำรายการ',
      width: '12rem',
      class: {
        cell: 'text-right',
        text: 'text-right',
      },
      filter: (val: any) => val?.name || '-',
    },
  },

  sortable: [
    'code',
    'itemsType',
    'dueDate',
    'updated_at',
    'created_at',
  ],
};
